<!DOCTYPE html>
<div class="main">
  <div class="holder_d border">
    <div class="box1 col_s">
      <img src="{{ userProfilePic }}" class="profile dTopImg" />
    </div>
    <div class="box2 col_o" [ngClass]="{ hidden: XpsValues?.vxp <= 0 }">
      <img src="../../../../assets/icon/purple.png" class="dTopImg2" alt="purple.png" />
    </div>
    <div class="box3 col_r" [ngClass]="{ hidden: XpsValues?.cxp <= 0 }">
      <img src="../../../../assets/icon/blue.png" class="dTopImg3" alt="blue.png" />
    </div>
    <div class="box4 col_p" [ngClass]="{ hidden: XpsValues?.fxp <= 0 }">
      <img src="../../../../assets/icon/green.png" class="dTopImg4" alt="green.png" />
    </div>
    <div class="box5 col_s" [ngClass]="{ hidden: XpsValues?.gxp <= 0 }">
      <img src="../../../../assets/icon/yellow.png" class="dTopImg5" alt="yellow.png" />
    </div>
  </div>

  <!-- c_xp: 20, v_xp: 0, f_xp: 20, g_xp: 0 -->

  <div class="holder_dB border">
    @if (XpsValues?.g_token > 0) {
      <span class="bottomImg12">
        <img src="assets/icon/games-fire-icon.png" />
        <span style="position: relative" class="text color"> {{ XpsValues?.g_token }}+ <br /> </span>
      </span>
    }
    <!-- CXP -->
    @if (XpsValues?.vxp > 0) {
      <span class="bottomImg2">
        <img src="../../../../assets/icon/purple.png" />
        <span style="position: relative" class="text color">+{{ XpsValues?.vxp }}</span>
      </span>
    }
    <!-- VXP -->
    @if (XpsValues?.cxp > 0) {
      <span class="bottomImg3">
        <img src="../../../../assets/icon/blue.png" alt="blue.png" />
        <span class="text color">+{{ XpsValues?.cxp }}</span>
      </span>
    }
    <!-- FXP -->
    @if (XpsValues?.fxp > 0) {
      <span class="bottomImg4">
        <img src="../../../../assets/icon/green.png" alt="green.png" />
        <span class="text color">+{{ XpsValues?.fxp }}</span>
      </span>
    }
    <!-- GXP -->
    @if (XpsValues?.gxp > 0) {
      <span class="bottomImg5">
        <img src="../../../../assets/icon/yellow.png" alt="yellow.png" />
        <span class="text color">+{{ XpsValues?.gxp }}</span>
      </span>
    }

    @if (XpsValues?.g_token > 0) {
      <span class="bottomImg6">
        <img src="assets/icon/games-fire-icon.png" alt="games-fire-icon.png" />
        <span class="text color">{{ XpsValues?.g_token }}+ <br /></span>
      </span>
    }

  </div>
  <!-- Event Name -->
  @if (eventName && eventName.length) {
    <div class="container" id="slideset2">
      @for (name of eventName; track name) {
        <div class="event-name">{{ name }}</div>
      }
    </div>
  }
</div>
